import ptBrTranslations from '../../assets/i18n/pt-br';
import enUsTranslations from '../../assets/i18n/en-us';
import esTranslations from '../../assets/i18n/es';

export default {
  'pt-BR': ptBrTranslations,
  pt: ptBrTranslations, // eslint-disable-line id-length
  'en-US': enUsTranslations,
  en: enUsTranslations, // eslint-disable-line id-length
  es: esTranslations // eslint-disable-line id-length
};
